import Api from './api';

const RhService = {
    login: async (params) => {
        const response = await Api.post('/rh/login', params);
        localStorage.setItem('rh', JSON.stringify(response.data.Rh));
        localStorage.setItem('nome', response.data.Rh["nome"]);
        localStorage.setItem('nivel', response.data.Rh["nivel"]);
        localStorage.setItem('token', response.data.token);
    },
    logout: () => {
        localStorage.removeItem('rh', null)
        localStorage.removeItem('token', null)
        localStorage.removeItem('nome', null)
    },
    cadastro: async (params) => {
        const response = await Api.post('/rh/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    listar: async (params) => {
        const response = await Api({
            method: 'get',
            url: '/rh/listar',
            params: params,
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    buscar: (params) => {
        const response = Api.get(`/rh/buscar?${params}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })

        return response
    },
    deletar: (id) => {
        Api.delete(`/rh/deletar/${id}`, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
    },
    rhEdit: async (id) => {
        const response = await Api.get(`/rh/editar/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    holerites: async (id) => {
        const response = await Api.get(`/holeriterh/holerites/${id}`,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    senha: async (id, params) => {
        const response = await Api.put(`/rh/senha/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    editar: async (id, params) => {
        const response = await Api.put(`/rh/editar/${id}`,
            params,
            { headers: { 'x-access-token': localStorage.getItem('token') } })
        return response
    },
    cadastroHolerite: async (params) => {
        const response = await Api.post('/holeriterh/cadastrar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    trocaHolerite: async (params) => {
        const response = await Api.put('/holeriterh/trocar', params, {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    delMesHolerite: async (mes, ano) => {
        const response = await Api.delete('/holeriterh/limpar-por-mes', {
            params: { mes, ano },
            headers: { 'x-access-token': localStorage.getItem('token') }
        });

        return response;
    },
    limparFuncionario: async (funcId, holId) => {
        const response = await Api.delete(`/holeriterh/limpar-funcionario/${funcId}/${holId}` , {
            headers: { 'x-access-token': localStorage.getItem('token') }
        })
        return response
    },
    viewHolerite: async (funcId, holeriteId) => {
        const response = await Api.get(
            `/holeriterh/ver/${funcId}/${holeriteId}`,
            {
                headers: { 'x-access-token': localStorage.getItem('token') },
                responseType: "blob"
            }
        );
        return response;
    }
}

export default RhService;
